// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle4 from "../../randing/RandingStyle4";

function Randing112({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/112/01.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/112/02.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/112/03.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/112/04.jpg`}
      benefitInfoPosition="bottom"
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton4.png`}
      companyName="우리바른치과의원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing112;
